"use strict";
/* globals module */
/**
 * @module MediaGalleryFileRoute
 * @description Baasic Media Gallery File Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery File Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var _1 = require("./");
var contracts_1 = require("../../core/contracts");
var MediaGalleryFileRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryFileRoute, _super);
    function MediaGalleryFileRoute(appOptions, mediaGalleryBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.mediaGalleryBatchRoute = mediaGalleryBatchRoute;
        _this.findRoute = 'media-gallery-files/{?searchQuery,fileName,minFileSize,maxFileSize,ids,from,to,page,rpp,sort,embed,fields,mediaGalleryIds,isCover}';
        _this.getRoute = 'media-gallery-files/{id}/{?embed,fields}';
        _this.updateRoute = 'media-gallery-files/{id}';
        _this.unlinkRoute = 'media-gallery-files/unlink({id}';
        _this.linkRoute = 'media-gallery-files/';
        return _this;
    }
    Object.defineProperty(MediaGalleryFileRoute.prototype, "batch", {
        get: function () {
            return this.mediaGalleryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing media gallery properties using the phrase search.
     * - `ids` - Comma separated list of media gallery ids to be retrieved.       *
     * - `from` - The from date.
     * - `to` - The to date.
     * - `page` - A value used to set the page number, i.e. to retrieve certain media gallery subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the media gallery property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example mediaGalleryFileRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaGalleryFileRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param id Media gallery file id which uniquely identifies media gallery resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example mediaGalleryFileRoute.get({id: '<media-gallery-id>'});
     **/
    MediaGalleryFileRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param data Media gallery file object used to update specific Media gallery file resource in the system.
     * @example mediaGalleryFileRoute.update(data);
     **/
    MediaGalleryFileRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this route should be expanded with the Id of media gallery file resource.
     * @method
     * @param id Media gallery file object id used to delete specific Media gallery file file resource in the system.
     * @example mediaGalleryFileRoute.delete({id: '<media-gallery-file--id>'});
     **/
    MediaGalleryFileRoute.prototype.unlink = function (id) {
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, id);
    };
    /**
    * Parses create route; this URI template doesnt support any additional options.
    * @method
    * @param data An media gallery file object that needs to be inserted into the system.
    * @example mediaGalleryFileRoute.create(data);
    **/
    MediaGalleryFileRoute.prototype.link = function (data) {
        return _super.prototype.baseCreate.call(this, this.linkRoute, data);
    };
    var _a, _b;
    MediaGalleryFileRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MediaGalleryFileBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.MediaGalleryFileBatchRoute !== "undefined" && _1.MediaGalleryFileBatchRoute) === "function" ? _b : Object])
    ], MediaGalleryFileRoute);
    return MediaGalleryFileRoute;
}(common_1.BaseRoute));
exports.MediaGalleryFileRoute = MediaGalleryFileRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
